import { GOCARDLESS } from "@/store/Gocardless/types";
export default {
    [GOCARDLESS](state, value) {
        state.gocardless = value;
    },
};
